import React from 'react'
import AddDistributor from './AddDistributor';

const EditDistributor = (props) => {
  return (
    <AddDistributor uuid={props.match.params.uuid} />
  )
}

export default EditDistributor;